import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptadorService implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          // Verifica se a API retornou um erro "de negócio" no corpo de uma resposta 200 OK
          if (body && body.sucesso === false && body.errors && Array.isArray(body.errors)) {
            body.errors.forEach((err: any) => {
              this.toastr.error(err.mensagem || 'Ocorreu um erro inesperado');
            });
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        let mensagemErro = 'Ocorreu um erro de comunicação com o servidor';

        if (error.error) {
          if (error.error.errors && Array.isArray(error.error.errors) && error.error.errors.length > 0) {
            error.error.errors.forEach((err: any) => {
              this.toastr.error(err.mensagem || 'Erro desconhecido');
            });
            return throwError(error);
          } else if (error.error.mensagem) {
            mensagemErro = error.error.mensagem;
          } else if (typeof error.error === 'string' && error.error.length < 200) {
            mensagemErro = error.error;
          }
        }

        this.toastr.error(mensagemErro);
        return throwError(error);
      })
    );
  }
}
